<template>
    <div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="userLevelCanConfigList"
                    row-key="levelCode + levelScore"
                    height="100%">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="用户层级" align="center" prop="levelName"/>
                <!--<el-table-column label="用户层级分值" align="center" prop="levelScore"/>-->
                <el-table-column label="显示名称" align="center">
                    <template slot-scope="scope">
                        <input-set-value
                                :defaultValue="scope.row.levelShowName"
                                size="mini"
                                width="200px"
                                @my-submit="updateFunc(scope.row,$event)"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex'
    import inputSetValue from 'components/inputSetValue'

    export default {
        components: {
            inputSetValue
        },
        data() {
            return {
                loading: false
            }
        },
        computed: {
            ...mapGetters('user', ['userLevelCanConfigList'])
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('user', ['getUserLevelConfigList', 'updateUserLevelConfig']),
            getList() {
                this.loading = true;
                this.getUserLevelConfigList().then(() => {
                    this.loading = false
                })
            },
            updateFunc(row, {value, cb}) {
                this.updateUserLevelConfig({
                    id: row.id,
                    levelCode: row.levelCode,
                    levelShowName: value
                }).then(() => {
                    this.$message.success('修改成功');
                    cb();
                    this.getList()
                })
            }
        }
    }
</script>